export class InformacionLaboral {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            tipo_vinculacion: {
                value: null,
                header: 'Tipo de Vinculación:',
                required: 'Seleccione una opción.'
            },
            tipo_relacion_laboral: {
                value: null,
                header: 'Tipo de Relación Laboral:',
                required: 'Seleccione una opción.'
            },
            nombre_empresa: {
                value: '',
                header: 'Nombre de la Empresa:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            ruc_empresa: {
                value: '',
                header: 'Número de Ruc:',
                required: 'RUC es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            actividad_economica: {
                value: null,
                header: 'Actividad Económica de la Empresa:',
                required: 'Seleccione una opción',
            },
            cargo_empresa: {
                value: '',
                header: 'Cargo que desempeña:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            ingreso_mensual: {
                value: 0,
                header: 'Ingresos Mensuales USD:',
                required: 'Valor requerido.'
            },
            direccion_empresa: {
                value: '',
                header: 'Dirección:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            pais_empresa: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia_empresa: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad_empresa: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton_empresa: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
                required: 'Ciudad es requerida'
            },
            telefono_empresa: {
                value: '',
                header: 'Teléfono:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 40,
                min: 4,
                required: 'Teléfono es requerida'
            },
            celular_empresa: {
                value: '',
                header: 'Celular:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 40,
                min: 3,
                required: 'Celular es requerido'
            },
            email_empresa: { 
                value: '', 
                header: 'E-Mail:', 
                maxLength: 'Máximo 200 caracteres', 
                minLength: 'Mínimo 4 caracteres', 
                max: 200, 
                min: 4 
            }, 
            tipo_relacion_laboral_cy: {
                value: null,
                header: 'Tipo de Relación Laboral:',
                required: 'Seleccione una opción.'
            },
            empresa_cy: {
                value: '',
                header: 'Empresa:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            cargo_cy: {
                value: '',
                header: 'Cargo:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
            },
            actividad_economica_cy: {
                value: null,
                header: 'Actividad Económica:',
                required: 'Seleccione una opción',
            },
            ingreso_mensual_cy: {
                value: 0,
                header: 'Ingresos Mensuales:',
                required: 'Valor requerido.'
            },
            direccion_cy: {
                value: '',
                header: 'Dirección:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            pais_cy: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia_cy: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad_cy: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton_cy: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4,
                required: 'Ciudad es requerida'
            },
            telefono_cy: {
                value: '',
                header: 'Teléfono:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 40,
                min: 4,
                required: 'Teléfono es requerida'
            },
            celular_cy: {
                value: '',
                header: 'Celular:',
                maxLength: 'Máximo 40 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 40,
                min: 3,
                required: 'Celular es requerido'
            },
            email_cy: { 
                value: '', 
                header: 'E-Mail:', 
                maxLength: 'Máximo 200 caracteres', 
                minLength: 'Mínimo 4 caracteres', 
                max: 200, 
                min: 4 
            }, 
        }
    }

    optionLabel = 'nombre';
}
